<div class="overview-container" [ngClass]="{ 'single-column': !incidentManagementEnabled }">
  <div class="grid-container">
    <dx-scroll-view [height]="getContainerHeight()" [useNative]="true">
      <dx-data-grid #overviewDataGrid
                    [dataSource]="data"
                    [allowColumnReordering]="false"
                    [allowColumnResizing]="true"
                    [columnAutoWidth]="true"
                    [showBorders]="true"
                    [keyExpr]="'K3VRowKey'"
                    [width]="getGridWidth()"
                    [loadPanel]="loadPanelConfiguration"
                    [hoverStateEnabled]="true"
                    (onRowDblClick)="rowDblClick($event)">
        <dxi-column [cellTemplate]="'cellTemplateImage'" [fixed]="true">
          <div *dxTemplate="let row of 'cellTemplateImage'">
            <img [src]="getRowImage(row.data)" alt="" class="row-image"/>
          </div>
        </dxi-column>
        <dxi-column [cellTemplate]="'cellTemplateEdit'" [fixed]="true">
          <div *dxTemplate="let row of 'cellTemplateEdit'" (click)="edit(row.data)">
            <i class="dx-icon-edit edit-icon-cursor-style"></i>
          </div>
        </dxi-column>
        <ng-container *ngFor="let headerColumn of headerColumns">
          <dxi-column [caption]="headerColumn.DisplayName" [dataField]="headerColumn.FieldName"
                      [dataType]="headerColumn.dataType" [format]="headerColumn.format"></dxi-column>
        </ng-container>
        <dxo-scrolling [columnRenderingMode]="'virtual'" [useNative]="true"></dxo-scrolling>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-paging [pageSize]="10"></dxo-paging>
        <dxo-pager [visible]="true"
                   [allowedPageSizes]="allowedPageSizes"
                   [displayMode]="pagerDisplayMode"
                   [showPageSizeSelector]="true"
                   [showInfo]="true"
                   [showNavigationButtons]="true">
        </dxo-pager>
        <dxo-master-detail [enabled]="incidentManagementEnabled" [template]="'referencedData'"></dxo-master-detail>
        <div *dxTemplate="let row of 'referencedData'">
          <app-reference-data *ngIf="incidentManagementEnabled" [rowKey]="row.key" [rowData]="row.data"></app-reference-data>
        </div>
      </dx-data-grid>
      <div class="right-buttons">
        <dx-button id="btnReset" text="{{'Reset Filters' | translate}}" type="default"
                   (onClick)="resetGridFilters()"></dx-button>
        <dx-button id="btnCollapse" text="{{'Collapse All' | translate}}" type="default"
                   (click)="collapseGridRows()"></dx-button>
      </div>
    </dx-scroll-view>
  </div>
  <div class="configuration-container">
    <dx-check-box #reports
                  [id]="reportsCheckBoxId"
                  [value]="true"
                  [text]="'Reports' | translate"
                  (onValueChanged)="configurationValueChanged($event)">
    </dx-check-box>
    <dx-check-box #incidents
                  [id]="incidentsCheckBoxId"
                  [value]="false"
                  [text]="'Incidents' | translate"
                  (onValueChanged)="configurationValueChanged($event)">
    </dx-check-box>
    <dx-check-box #mixed
                  [id]="mixedCheckBoxId"
                  [value]="false"
                  [text]="'Mixed' | translate"
                  (onValueChanged)="configurationValueChanged($event)">
    </dx-check-box>
  </div>
</div>


